module.exports = __webpack_public_path__ + "img/bg_company.ea7db538.svg";